/**
 * @param{String} isoDate
 * @return{String}
 */
export default function removeTzFromIsoDate(isoDate = '') {
  return isoDate.substring(0, 19);
}
